import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'serp/:url',
  async getComponent (nextState) {
    const {
      default: SerpContainer
    } = await import(/* webpackChunkName: "serp-container" */ './containers/SerpContainer')
      .catch(handleChunkLoadError);
    return SerpContainer;
  },
  getData: ({ context: { props } }) => props || {},
  children: [
    {
      path: 'keyword/:keywordId',
      async getComponent (nextState) {
        const {
          default: KeywordPage
        } = await import(/* webpackChunkName: "serp-keyword" */ './containers/KeywordPage')
          .catch(handleChunkLoadError);
        return KeywordPage;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'add',
      async getComponent (nextState) {
        const {
          default: AddKeywordsPage
        } = await import(/* webpackChunkName: "serp-add" */ './containers/AddKeywordsPage')
          .catch(handleChunkLoadError);
        return AddKeywordsPage;
      },
      getData ({ context: { props } }) {
        return props ? { ...props, hideFooter: true } : props;
      }
    },
    {
      path: 'add/:domain',
      async getComponent (nextState) {
        const {
          default: AddKeywordsPage
        } = await import(/* webpackChunkName: "serp-add-domain" */ './containers/AddKeywordsPage')
          .catch(handleChunkLoadError);
        return AddKeywordsPage;
      },
      getData ({ context: { props } }) {
        return props ? { ...props, hideFooter: true } : props;
      }
    },
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: SerpPage
        } = await import(/* webpackChunkName: "serp-page" */ './components/SerpPage')
          .catch(handleChunkLoadError);
        return SerpPage;
      },
      getData ({ context: { props } }) {
        return props;
      }
    }
  ]
});
